module.exports = __webpack_public_path__ + "img/shopping_application_1.d210774d.jpg";